import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ShippingMethodsDetailConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Styles.InputsRow>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.InputsRow>
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Styles.Section>
        <Skeleton variant="text" width={140} height={24} />
        <Skeleton variant="rounded" width="100%" height={120} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={120} height={24} />
        <Styles.InputsRow>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.InputsRow>
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={180} height={24} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Styles.InputsRow>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.InputsRow>
      </Styles.Section>

      <Divider />

      <Styles.Section>
        <Skeleton variant="text" width={160} height={24} />
        <Styles.InputsRow>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
        </Styles.InputsRow>
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={220} height={20} />
        </Styles.ToggleRow>
        <Styles.ToggleRow>
          <Skeleton variant="rounded" width={48} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Styles.ToggleRow>
      </Styles.Section>
    </Styles.Container>
  )
}

export default ShippingMethodsDetailConfigurationSkeleton
